<template>
   <app-master>

       <div slot='breadcrumb'>
         <app-breadcrumb>
             <div class="title-box ttm-textcolor-white">
                <div class="page-title-heading">
                    <h1 class="title">Asset Management</h1>
                </div><!-- /.page-title-captions -->
                <div class="breadcrumb-wrapper">
                    <div class="container">
                        <div class="breadcrumb-wrapper-inner">
                            <span>
                                <router-link class="home" title='Go to AgroPark' to='/'><i class="themifyicon ti-home"></i>&nbsp;&nbsp;Home </router-link>
                            </span>
                            <span class="ttm-bread-sep">&nbsp; | &nbsp;</span>
                            <span>Asset Management</span>
                        </div>
                    </div>
                </div>
            </div>
         </app-breadcrumb>
       </div>
        



      <div slot='main_content'>

         <!--introduction-section-->
        <section class="ttm-row introduction-section clearfix">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-xs-12">
                        <div class="pt-50 res-991-pt-0">
                            <!-- section title -->
                            <div class="section-title clearfix">
                                <div class="title-header">
                                    <!-- <h5>OUR MEDICAL</h5> -->
                                    <h2 class="title">Green Asset Management</h2>
                                </div>
                            </div><!-- section title end -->
                            <div class="mb-30 clearfix">
                                <p>What is a Green Asset? For something to be a green asset, it must have social, economic, and environmental value. For us, this includes farmland and rural properties. A green asset can be owned by a person, company, or group of people, usually a family or community.</p>
                                <p>Several factors militate against the ability of farmland owners to effectively harness the benefits of their asset, such as lack of access to planting materials, enabling technologies, and the key indicators that define and monitor the performance of an asset. These factors determine in the long run, if an asset would yield real value. </p>
                                <p>We bring practical solutions to these challenges. Farmland owners who choose to leverage the facilities we provide have the option to trade their entire asset, or form a technical partnership to access our materials, technology, and competent human resource. </p>
                            </div>
                            <!-- <h5>Delmont Special Features</h5> -->
                            <!-- <div class="row">
                                <div class="col-md-6">
                                    <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Adult Trauma Center</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Birthing and Lactation Classes</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Dental and Oral Surgery</span></li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Children's Trauma Center</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Heart and Vascular Institute</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Plastic Surgery</span></li>
                                    </ul>
                                </div>
                                <div class="col-lg-12">
                                    <div class="mt-25 res-991-mt-0 res-991-mb-40">
                                        <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-black mr-15 mt-15" href="#">VIEW MORE</a>
                                        <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-fill ttm-btn-color-skincolor mt-15" href="#">CONTACT US!</a>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-lg-6 col-xs-12">
                        <!-- ttm_single_image-wrapper -->
                        <div class="ttm_single_image-wrapper text-right">
                            <img class="img-fluid" src="images/single-img-twel.jpg" alt="">
                        </div>
                        <div class="about-overlay-shape">
                            <div class="row">
                                <div class="col-lg-2 col-sm-3"></div>
                                <!-- <div class="col-lg-10 col-sm-6">
                                    <div class="about-content ttm-col-bgcolor-yes ttm-bg ttm-bgcolor-darkgrey mt_50 pl-35 pt-15 ttm-textcolor-white">
                                        <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                                        <div class="layer-content">
                                            <h5 class="font-weight-normal mb-10">We <span class="ttm-textcolor-skincolor"> &nbsp;<i class="fa fa-heart-o"></i>&nbsp; </span> To Care our <span class="ttm-textcolor-skincolor"> Patients !</span></h5>
                                        </div>
                                    </div> -->
                                    <!-- ttm_single_image-wrapper end -->
                                <!-- </div> -->
                                <div class="col-sm-3"></div>
                            </div>
                        </div>
                    </div>
                </div><!-- row end -->
            </div>
        </section>
        <!--introduction-section end-->




        
<section class="ttm-row pb-70 res-991-pb-20 clearfix" style="padding-top: 10px">
            <div class="container">
                <!-- row -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="ttm-tabs">

                            <div class="content-tab pt-20">
                                <!-- content-inner -->
                                <div class="content-inner active">
                                    <div class="row multi-columns-row ttm-boxes-row-wrapper">
                                       <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                            <!-- featured-imagebox -->
                                            <div class="featured-imagebox featured-imagebox-portfolio ttm-box-view-top-image ttm-box-view-top-image">
                                                <div class="ttm-box-view-content-inner">
                                                    <!-- featured-thumbnail -->
                                                    <div class="featured-thumbnail">
                                                        <a href="#"> <img class="img-fluid" src="/img/fam.png" alt="image"></a>
                                                    </div><!-- featured-thumbnail end-->
                                                    <!-- ttm-box-view-overlay -->
                                                    <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                                        <div class="featured-iconbox ttm-media-link">
                                                            <a class="ttm_prettyphoto ttm_image" title="Pen" data-rel="prettyPhoto" href="/img/fam.png">
                                                                <i class="ti ti-search"></i>
                                                            </a>
                                                        </div>
                                                    </div><!-- ttm-box-view-overlay end-->
                                                </div>
                                                <div class="ttm-box-bottom-content featured-content-portfolio box-shadow">
                                                    <div class="featured-title">
                                                        <h5><router-link to="/farmland-subscription" tag="a"> Farmland Subscription </router-link></h5>
                                                    </div>
                                                    <span class="category">
                                                        <a href="#">Starting from, </a>
                                                        <a href="#">N457,000</a>
                                                    </span>
                                                </div>
                                            </div><!-- featured-imagebox -->
                                        </div>
                                        <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                            <!-- featured-imagebox -->
                                            <div class="featured-imagebox featured-imagebox-portfolio ttm-box-view-top-image">
                                                <div class="ttm-box-view-content-inner">
                                                    <!-- featured-thumbnail -->
                                                    <div class="featured-thumbnail">
                                                        <a href="#"> <img class="img-fluid" src="/img/fish.png" alt="image"></a>
                                                    </div><!-- featured-thumbnail end-->
                                                    <!-- ttm-box-view-overlay -->
                                                    <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                                        <div class="featured-iconbox ttm-media-link">
                                                            <a class="ttm_prettyphoto ttm_image" title="Fish pond" data-rel="prettyPhoto" href="/img/fish.png">
                                                                <i class="ti ti-search"></i>
                                                            </a>
                                                        </div>
                                                    </div><!-- ttm-box-view-overlay end-->
                                                </div>
                                                <div class="ttm-box-bottom-content featured-content-portfolio box-shadow">
                                                    <div class="featured-title">
                                                       <h5><router-link to="/fishery-subscription" tag="a"> Fishery Subscription </router-link></h5>
                                                    </div>
                                                    <span class="category">
                                                        <a href="#">As low as ,</a>,
                                                        <a href="#"> N247,999</a>
                                                    </span>
                                                </div>
                                            </div><!-- featured-imagebox -->
                                        </div>
                                        <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                            <!-- featured-imagebox -->
                                            <div class="featured-imagebox featured-imagebox-portfolio ttm-box-view-top-image">
                                                <div class="ttm-box-view-content-inner">
                                                    <!-- featured-thumbnail -->
                                                    <div class="featured-thumbnail">
                                                        <a href="#"> <img class="img-fluid" src="/img/oil.png" alt="image"></a>
                                                    </div><!-- featured-thumbnail end-->
                                                    <!-- ttm-box-view-overlay -->
                                                    <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                                        <div class="featured-iconbox ttm-media-link">
                                                            <a class="ttm_prettyphoto ttm_image" title="Oilpalm" data-rel="prettyPhoto" href="/img/oil.png">
                                                                <i class="ti ti-search"></i>
                                                            </a>
                                                        </div>
                                                    </div><!-- ttm-box-view-overlay end-->
                                                </div>
                                                <div class="ttm-box-bottom-content featured-content-portfolio box-shadow">
                                                    <div class="featured-title">
                                                        <h5><router-link to="/cashcrop-subscription" tag="a"> CashCrop Subscription </router-link></h5>
                                                    </div>
                                                    <span class="category">
                                                        <a href="#">Starting from,</a>,
                                                        <a href="#"> N457,000</a>
                                                    </span>
                                                </div>
                                            </div><!-- featured-imagebox -->
                                        </div>
                                      
                                    </div><!-- row end -->
                                </div>





                            </div>
                        </div>
                    </div>
                </div><!-- row end -->
            </div>
        </section>

         
        
      </div>

   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue"
import Breadcrumb from "@/components/Breadcrumb.vue"
import { seo } from "../Repositories/seo"

export default {
  name: "AssetManagement",
  mixins: [seo],
  components: {
    "app-master" : Master,
    "app-breadcrumb" : Breadcrumb

  },
  created(){
      this.seoMetaData('Asset Management', '');
  }

};
</script>
